<div class="detail-container">
  <h4 class="secondary-header secondary-header-boder">{{ title }}</h4>
  <div class="lab-list">
    <ul>
      <li *ngFor="let data of dataOption, let j = index">
        <!-- Caso: es un link -->
        <a *ngIf="data.isLink" target="_blank" [href]="data.value ? data.value : ''">
          <b>{{ data.label ? data.label : '' }}</b>
        </a>

        <!-- Caso: no es link pero tiene un mapa -->
        <ng-container *ngIf="!data.isLink && data?.map">
          <gis-map [positionInput]="getPositionByDireccionGeografica(data.map.input)"></gis-map>
        </ng-container>

        <!-- Caso: no es link ni mapa -->
        <span *ngIf="!data.isLink && !data.map && data.label">
          <b>{{ data.label }}</b>:{{ ' ' }}
        </span>
        <span *ngIf="!data.isLink && !data.map && data.value">
          {{ data.value ? data.value : '' }}
        </span>

        <!-- Caso: children -->
        <div class="children" *ngFor="let children of data.children, let i = index">
          <!-- Caso: es un label para mostrar -->
          <span *ngIf="getLabelToShow(children.label)">
            <!-- <ng-container *ngIf="children.onRender">
              - <b class="label">{{children.label}}</b>: {{' '}}
              <span style="margin-left: 15px" [innerHTML]="children.onRender(children.value)"></span>
            </ng-container> -->
            <ul class="flex">
              <b class="margin">-</b>
              <b>{{ children.label }}:</b>{{ ' ' }}
              <div class="column">
                <li class="li-new" *ngFor="let item of getSplit(children.value)">
                  <span [innerHTML]="formatBoldText(item)"></span>
                </li>
              </div>
            </ul>
          </span>
          <!-- Caso: no es un label pero es un mapa -->
          <ng-container *ngIf="!getLabelToShow(children.label)">
            <ng-container *ngIf="children.onRender">
              - <b class="label">{{children.label}}</b>: {{' '}}
              <span style="margin-left: 15px" [innerHTML]="children.onRender(children.value)"></span>
            </ng-container>
            <ng-container *ngIf="children?.map?.input?.latitud && children?.map?.input?.longitud">
              <div class="flex-map">
                <div>
                  - <b class="label">Mapa</b>:
                </div>

                <rpe-ui-button (onClick)="toggle(j, i)" [full_width]="true" [bg_blue]="true"
                  [icon]="isChildExpanded(j, i) ? 'location_off' : 'location_on'">
                  {{ isChildExpanded(j, i) ? 'Ocultar mapa' : 'Ver mapa' }}
                </rpe-ui-button>
              </div>

              <div *ngIf="isChildExpanded(j, i)">
                <ng-container *ngIf="children.map?.input as coords">
                  <gis-map [positionInput]="getPositionByDireccionGeografica(children.map.input)"></gis-map>
                </ng-container>
              </div>
            </ng-container>
            <!-- Caso: no es un label ni un mapa pero es un link -->
            <a *ngIf="children.isLink && children.value !== null" target="_blank"
              [href]="children.value ? children.value : ''">
              <b>{{ children.label ? children.label : '' }}</b>
            </a>
            <!-- Caso: no es un link ni un mapa -->

            <ng-container *ngIf="!children.isLink && !children.map && !children.onRender">
              - <b>{{ children.label }}</b>: {{ ' ' }}
              <span [ngClass]="children?.valueColor">{{ children.value ? children.value : '' }}</span>
            </ng-container>
          </ng-container>
        </div>
      </li>
    </ul>
  </div>
</div>